// User-facing copy: notifications. Moved from the web app (components/Bell.tsx, components/NotificationSettings.tsx, components/PushAsk.tsx, pages/Inbox.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** components/Bell.tsx */
export const bell = {
    inboxUnread: (n) => `Inbox, ${n} unread`,
    inbox: "Inbox",
};
/** components/NotificationSettings.tsx */
export const settings = {
    thingsMeantForYou: "Things meant for you. On to start with.",
    yourClubsMeetings: "Your clubs' meetings.",
    whatYourClubsRead: "What your clubs read next.",
    forOwnersAndAdmins: "For owners and admins.",
    whatSHappeningIn: "What's happening in your clubs. Off to start with.",
    thisPhoneOrBrowser: "This phone or browser gets notifications. Each device you use has its own switch.",
    thisPhoneOrBrowser2: "This phone or browser doesn't get notifications. Your inbox still has everything.",
    notificationsAreBlockedFor: "Notifications are blocked for Pagemates in this browser's settings. Allow them there, then come back.",
    onIphoneAndIpad: "On iPhone and iPad, add Pagemates to your Home Screen first (in Safari: Share, then Add to Home Screen), then open it from there.",
    thisBrowserCanT: "This browser can't get notifications. Your inbox still has everything.",
    thisServerDoesnT: "This server doesn't send push notifications. Your inbox still has everything.",
    device: "device",
    notifications: "Notifications",
    whatReachesYouAnd: "What reaches you, and how.",
    yourInboxGetsEverything: "Your inbox gets everything. These choose what also comes as a push or an email. They say who and where, never what was said.",
    pushOnThisDevice: "Push on this device",
    thisBrowser: "This browser",
    checking: "Checking…",
    otherDevices: (length) => `Other devices: ${length} ›`,
    sendEmailsTo: "Send emails to",
    confirmed: "Confirmed",
    hiddenByApple: "Hidden by Apple",
    nowhereRightNow: "Nowhere right now.",
    noAddressYet: "No address yet.",
    change: "Change",
    waitingForYouTo: "Waiting for you to confirm",
    weSentItA: (x) => `We sent it a code.${x}`,
    emailsKeepGoingTo: (address) => ` Emails keep going to ${address} until then.`,
    enterTheCode: "Enter the code",
    appleForwardsTheseTo: "Apple forwards these to your real inbox. You can use another address instead.",
    weCouldnTDeliver: "We couldn't deliver to your address, so we've stopped sending to it.",
    chooseAnotherAddress: "Choose another address",
    addAnAddress: "Add an address",
    oneOfOurEmails: "One of our emails was marked as spam, so email is off. Your inbox and pushes carry on.",
    emailIsOffYou: "Email is off: you stopped it from an email's link.",
    email: "Email",
    turnEmailBackOn: "Turn email back on",
    quietHours: "Quiet hours",
    pushesWaitThenArrive: "Pushes wait, then arrive as one summary when quiet hours end. Email isn't held.",
    from: "From ",
    until: "until ",
    timesAre: "Times are ",
    inYourClubOwner: "in your club owner's time zone until this browser tells us yours",
    use: (replace) => `Use ${replace}`,
    whatReachesYou: "What reaches you",
    yourInboxGetsEverything2: (x) => `Your inbox gets everything. Choose what also comes as a push or an email.${x}`,
    addAnEmailAddress: " Add an email address to use the Email column.",
    kindOfNotification: "Kind of notification",
    push: "Push",
    inboxOnly: "Inbox only",
    changeThatInEach: (x) => `${x}. Change that in each club's settings, under Your membership.`,
    n1ClubMuted: "1 club muted",
    no: (toLowerCase) => `No ${toLowerCase}`,
    alwaysSentBecauseIt: "Always sent, because it affects your account",
    on: "On",
    devicesThatGetPush: "Devices that get push",
    thisDevice: "this device",
    lastReached: (toLocaleDateString) => `last reached ${toLocaleDateString}`,
    notReachedYet: "not reached yet",
    remove: "remove",
    aRemovedDeviceStops: "A removed device stops getting push. Signing in there and turning push on adds it back.",
    muteThisClub: "Mute this club",
    nothingFromThisClub: "Nothing from this club notifies you, except someone asking to take it over. Your inbox stays as it is.",
    clubsMuted: (length) => `${length} clubs muted`,
};
/** components/PushAsk.tsx */
export const pushAsk = {
    getAReminderThe: "Get a reminder the day before?",
    pagematesCanTellYou: "Pagemates can tell you the day before, and if the date moves.",
    wantToKnowWhen: "Want to know when someone answers?",
    youLlHearWho: "You'll hear who answered. The answer itself waits in Talk, sealed if it's past where you are.",
    hearWhenPeopleAsk: "Hear when people ask to join?",
    soNobodyWaitsLong: "So nobody waits long for an answer.",
    notifications: "Notifications",
    addPagematesToYour: "Add Pagemates to your Home Screen to get notifications",
    inSafariTapShare: "In Safari, tap Share, then Add to Home Screen, and open it from there.",
    gotIt: "Got it",
    turnOnNotifications: "Turn on notifications",
    notNow: "Not now",
    close: "Close",
};
/** pages/Inbox.tsx */
export const inbox = {
    yourClubs: "Your clubs",
    markAllRead: "Mark all read",
    inbox: "Inbox",
    nothingYet: "Nothing yet",
    repliesMeetingsAndNews: "Replies, meetings and news from your clubs land here.",
    loading: "Loading…",
    older: "Older",
    alsoPushed: "also pushed",
    alsoEmailed: "also emailed",
    chooseWhereThingsGo: "Choose where things go",
    sealedUntil: (sealedAt) => `sealed until ${sealedAt}%`,
    alsoPushed2: "Also pushed",
    alsoEmailed2: "Also emailed",
    unread: "Unread",
};
//# sourceMappingURL=notifications.js.map